import React, { Fragment, useRef } from "react";
import { string, number, node, oneOfType, func, bool } from "prop-types";
import * as styles from "./styles.module.scss";

const RETURN_KEY = 8;

const MultiInput = ({
  inputId = "",
  inputName = "",
  type = "text",
  placeholder,
  numberOfInputs,
  separator = "-",
  value,
  classes,
  onChange,
  isDisabled,
  validationMessages,
}) => {
  const inputRefs = useRef([]);
  const inputLength = placeholder.length / numberOfInputs;

  const selfOnChange = (e) => {
    const {
      value: inputValue,
      dataset: { index },
    } = e.target;
    const nextInput = inputRefs.current[Number(index) + 1];

    if (inputValue.length >= inputLength && nextInput) {
      nextInput.focus();
    }

    const concatenatedValue = inputRefs.current
      .map((input) => input.value)
      .join("");

    // Faking HTMLChangeEvent with necesararary data
    onChange({ target: { name: inputName, value: concatenatedValue } });
  };

  const handleOnKeyDown = (e) => {
    if (e.keyCode !== RETURN_KEY) return;
    const {
      value: inputValue,
      dataset: { index },
    } = e.target;

    const previousInput = inputRefs.current[Number(index) - 1];

    if (inputValue.length === 0 && previousInput) {
      previousInput.focus();
    }
  };

  return Array.from({ length: numberOfInputs }, (_, index) => {
    const inputValue = value.substr(index * inputLength, inputLength);
    const inputPlaceholder = placeholder.substr(
      index * inputLength,
      inputLength
    );

    return (
      <Fragment key={index}>
        <input
          id={`${inputId}-${index}`}
          name={inputName}
          ref={(ref) => {
            inputRefs.current[index] = ref;
          }}
          type={type}
          data-index={index}
          className={`${classes || ""} form-control ${styles.multiInput} ${
            validationMessages ? styles.multiInput__error : ""
          }`}
          placeholder={inputPlaceholder}
          value={inputValue}
          disabled={isDisabled}
          onChange={selfOnChange}
          onKeyDown={handleOnKeyDown}
        />
        {index !== numberOfInputs - 1 && (
          <div style={{ display: "inline-block", margin: "0 5px" }}>
            {separator}
          </div>
        )}
      </Fragment>
    );
  });
};

MultiInput.propTypes = {
  inputId: string,
  inputName: string,
  type: string,
  placeholder: string,
  numberOfInputs: number,
  separator: oneOfType([node, string]),
  value: string,
  classes: string,
  onChange: func,
  isDisabled: bool,
};

export default MultiInput;
